import { createRoot } from 'react-dom/client';
import Diagnostic from '../components/Diagnostic';
import Quoter from '../components/Quoter';
import useQuotation from '../hooks/useQuotation';
import QuotationPayment from '../components/QuotationPayment';
import QuotationSummary from '../components/QuotationSummary';
import PaymentButton from '../components/PaymentButton';
//import ProductVisualizer from '../components/ProductVisualizer';

let diagnosticRoot = null;
// let diagnosticRootElement = null;

const getQuotationId = () => {
    const parts = window.location.pathname.split('/');
    return parseInt(parts[parts.length - 1]);
};

const init = (renderDiagnostic = false) => {
    const { getQuotation, getPayment } = useQuotation();
    const quotationId = getQuotationId();

    Promise.all([getQuotation(quotationId), getPayment(quotationId)]).then(([quotation, payment]) => {
        const diagnosticElement = document.getElementById('quotation-diagnostic');
        if (renderDiagnostic) {
            if (diagnosticElement) {
                /* 
                if (diagnosticRoot && diagnosticRootElement === diagnosticElement && diagnosticElement.isConnected) {
                    diagnosticRoot.unmount();
                }
                if (!diagnosticRoot) {
                    diagnosticRoot = createRoot(diagnosticElement);
                }  
                */
                diagnosticRoot = createRoot(diagnosticElement);
                //diagnosticRootElement = diagnosticElement;
                diagnosticRoot.render(<Diagnostic quotation={quotation} />);
            }
        } else {
            if (document.getElementById('quotation-summary')) {
                createRoot(document.getElementById('quotation-summary')).render(<QuotationSummary quotation={quotation} payment={payment} />);
            }

            if (document.getElementById('quotation-payment')) {
                createRoot(document.getElementById('quotation-payment')).render(<QuotationPayment quotation={quotation} payment={payment} />);
            }

            if (diagnosticElement) {
                if (diagnosticRoot) diagnosticRoot.unmount();
                diagnosticRoot = createRoot(diagnosticElement);
                diagnosticRoot.render(<Diagnostic quotation={quotation} />);
            }

            if (document.getElementById('quotation-quoter')) {
                createRoot(document.getElementById('quotation-quoter')).render(<Quoter quotation={quotation} payment={payment} />);
            }

            if (document.getElementById('payment-button')) {
                createRoot(document.getElementById('payment-button')).render(<PaymentButton quotation={quotation} />);
            }
            /* 
            if (document.getElementById('product-visualizer')) {
                createRoot(document.getElementById('product-visualizer')).render(<ProductVisualizer quotation={quotation} />);
            }
            */
        }
    });
};

window.livewire.on('submittedDoctor', () => {
    init(true);
});

export default init;
